// extracted by mini-css-extract-plugin
export default {"makerGreen":"#385461","makerWhite":"white","fontmicro":"0.2em","container":"footer_container__eqC0m","footer":"footer_footer__yfnpp","right":"footer_right__WDUK8"};